import { Link, useParams } from 'react-router-dom';
import Across from 'assets/icons/Across';
import { errorHandler } from 'utils/helpers/errorHandler';
import { errorToast, successToast } from 'utils/helpers/notify';
import { Role } from 'generated/graphql';
import { useRemoveResponsibleFromTheObjectMutation } from '../../api/mutations/generated/RemoveResponsibleFromTheObject';
import { updateObjectResponsibleUsersCache } from './writeCache';

interface Props {
  user: any;
  canRemove?: boolean;
}

const ResponsibleUser = ({ user, canRemove = true }: Props) => {
  const { facilityId } = useParams();
  const { lastname, firstname, id: userId, role } = user;
  const [removeResponsible] = useRemoveResponsibleFromTheObjectMutation({
    update: cache => {
      if (!facilityId) return;
      updateObjectResponsibleUsersCache(cache, { objectId: facilityId, userId });
    },
  });

  const handleRemoveUser = async () => {
    if (!facilityId) return;

    await removeResponsible({
      variables: {
        input: {
          objectId: facilityId,
          userId,
        },
      },
    })
      .then(() => {
        let roleText = '';
        switch (role) {
          case Role.Supervisor:
            roleText = 'Супервайзер';
            break;
          case Role.Foreman:
            roleText = 'Бригадир';
            break;
          case Role.ClientManager:
            roleText = 'Менеджер';
            break;
          case Role.ClientDirector:
            roleText = 'Директор';
            break;
        }
        successToast(`${roleText} успешно удален`);
      })
      .catch(e => {
        errorToast(errorHandler(e));
      });
  };

  return (
    <div className="grid grid-cols-[1fr_60px] items-center h-6">
      <Link to={`/users/${userId}`} className="col-auto Body2 text-primary" title={`${lastname} ${firstname}`}>
        {lastname + ' ' + firstname}
      </Link>
      {canRemove && (
        <button className="auto-cols-max flex justify-center" type="button" onClick={handleRemoveUser}>
          <Across className="text-smena_red" />
        </button>
      )}
    </div>
  );
};

export default ResponsibleUser;
